import { createContext, useContext, useEffect, useState } from "react";
import { api, defaultSettings } from "@/lib/api";

const SettingsContext = createContext({ settings: defaultSettings, refreshSettings: () => {} });

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(defaultSettings);
  const refreshSettings = () => api("/public/settings").then(d => setSettings({ ...defaultSettings, ...d })).catch(() => {});
  useEffect(() => { refreshSettings(); }, []);
  return <SettingsContext.Provider value={{ settings, refreshSettings }}>{children}</SettingsContext.Provider>;
};

export const useSettings = () => useContext(SettingsContext).settings;
export const useRefreshSettings = () => useContext(SettingsContext).refreshSettings;
